const team = [
  {
    name: "Ben Zhang",
    role: "FOUNDER & CEO",
    photo: "/team-ben.jpg",
    pos: "center top",
    bio: "Background in regulated technology and financial services. Built and scaled products across immigration, fintech, and education. Leads company strategy, client relationships, and platform vision.",
  },
  {
    name: "Hugh Carnegie",
    role: "OPERATIONS",
    photo: "/team-hugh.jpg",
    pos: "center 15%",
    bio: "Led start-up operations across multiple product launches. Builds the delivery infrastructure that ensures agents ship reliably and client onboarding runs smoothly. Operational playbook specialist.",
  },
  {
    name: "Cher Truman",
    role: "MARKETING & GROWTH",
    photo: "/team-cher.png",
    pos: "center 30%",
    bio: "Brand and media strategy background at WPP Media. International client acquisition across enterprise accounts. MSc Leeds and Executive Branding, Oxford.",
  },
  {
    name: "George Yang",
    role: "STRATEGIC ADVISOR",
    photo: "/team-george.png",
    pos: "center 35%",
    bio: "Deep connections across the AI ecosystem, including Anthropic, Stripe, and Databricks. Advises on strategic partnerships, market positioning, and cross-border expansion. Former partner at CVC and Pantheon Asset.",
  },
];

export function IntroTeamSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[32px] font-light tracking-tight font-[family-name:var(--font-heading)] mb-4">
        Built by operators, not just engineers.
      </h2>

      <div className="grid grid-cols-4 gap-4">
        {team.map((member) => (
          <div key={member.name}>
            <img
              src={member.photo}
              alt={member.name}
              className="w-full aspect-[4/3] object-cover bg-[var(--color-fg-tertiary)]/10"
              style={{ objectPosition: member.pos }}
              loading="eager"
            />
            <div className="mt-2">
              <p className="text-[10px] font-mono uppercase tracking-widest text-[var(--color-fg-tertiary)]">
                {member.role}
              </p>
              <p className="text-[14px] font-medium text-[var(--color-fg)]">
                {member.name}
              </p>
              <p className="text-[10px] text-[var(--color-fg-secondary)] leading-relaxed mt-1">
                {member.bio}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          5-person engineering team + AI agents ship around the clock.
        </p>
      </div>
    </div>
  );
}
